<template>
<svg :width="width" :height="height" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="30" height="30" rx="5" fill="#80B7FF"/>
<path d="M22 9L8 9" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M22 13L8 13" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M22 17L8 17" stroke="white" stroke-width="2" stroke-linecap="round"/>
<path d="M15 21H8" stroke="white" stroke-width="2" stroke-linecap="round"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 30 },
        height: { type: [Number, String], default: 30 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
